module.exports = __webpack_public_path__ + "img/logo_wide_dark.28d4b3e7.png";